var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("LayoutHeadingTabs", {
    staticClass: "automation-layout",
    attrs: { title: _vm.translations.title, isResponsiveCentered: "" },
    scopedSlots: _vm._u([
      {
        key: "tabs",
        fn: function() {
          return [_c("HeadingTabs", { attrs: { tabs: _vm.tabs } })]
        },
        proxy: true
      },
      {
        key: "actions",
        fn: function() {
          return [
            _c(
              "CompassMenu",
              {
                attrs: {
                  placement: "bottom-end",
                  customClass: "automation-layout__actions-menu"
                }
              },
              [
                _c("CompassButton", {
                  attrs: {
                    label: _vm.translations.createAutomation.labelButton,
                    loading: _vm.isLoadingCreation,
                    dropdown: ""
                  }
                }),
                _vm._v(" "),
                _c(
                  "template",
                  { slot: "dropdown" },
                  [
                    _c("CompassMenuItem", {
                      attrs: {
                        label: _vm.translations.createAutomation.automation,
                        icon: "obj-slsy-advanced-automation"
                      },
                      on: { click: _vm.handleCreateAutomation }
                    }),
                    _vm._v(" "),
                    _c("CompassMenuItem", {
                      attrs: {
                        label: _vm.translations.createAutomation.template,
                        icon: "obj-slsy-basic-automation"
                      },
                      on: { click: _vm.handleGoToTemplates }
                    })
                  ],
                  1
                )
              ],
              2
            )
          ]
        },
        proxy: true
      },
      {
        key: "content",
        fn: function() {
          return [_c("router-view", { key: _vm.$route.path })]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }